import React, { useMemo } from "react";
import {
  colors2,
  SimpleTable,
  BlockLabel,
  UI_BODY_SEMIBOLD_SM,
  UI_BODY_SM_DF,
  UI_CAPTION,
  icons,
  getVal,
  setVal
} from "oolib";
import styled from 'styled-components';
import { WIDGET_ELEM_someReqPropsUnset } from "./WIDGET_ELEM_someReqPropsUnset";
import { WidgetHeader } from "../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { WIDGET_ELEM_configForm } from "./WIDGET_ELEM_configForm";
import { convertTableDataToBarChartFormat } from "./utils/convertTableDataToBarChartFormat";
import { useUpdateLoadedWidgetsTracker } from "../../../ReportLandingContext/useUpdateLoadedWidgetsTracker";
import { BarChart } from "@/components/dataviz/BarChart";

export const Component = (props) => {
  
  const {
    id,
    widgetIdx,
    style = {},
    tableData, 
  } = props;

  useUpdateLoadedWidgetsTracker({status: 'success', widgetIdx})

  const barChartData = useMemo(() => {
    return convertTableDataToBarChartFormat(tableData);
  }, [tableData]);


  const genViz = () => {
    if (!barChartData || barChartData.length === 0) {
      return null
    }

    return (
        <BarChart
          data={barChartData}
          valuePath="value"
          labelPath="display"
          colorIdx={widgetIdx % 4}
          style={style}
        />
    );
  };

  return (
      genViz()
  );
};

export const ConfigForm = WIDGET_ELEM_configForm

export const optionDef = { 
  display: "Visualize Table", 
  icon: "Table", 
  value: "visualizeTable", 
  comp: 'WidgetVisualize' 
};

export const defaultConfig = {
  props: { 
    title: "", 
    tableData: {
      data: [
        {
          id: "row_1",
          cellData: [
            { id: "cell_1", value: "", comp: "RichTextEditor" },
            { id: "cell_2", value: "", comp: "NumberInput" } 
          ]
        },
        {
          id: "row_2", 
          cellData: [
            { id: "cell_3", value: "", comp: "RichTextEditor" },
            { id: "cell_4", value: "", comp: "NumberInput" } 
          ]
        },
        {
          id: "row_3",
          cellData: [
            { id: "cell_5", value: "", comp: "RichTextEditor" },
            { id: "cell_6", value: "", comp: "NumberInput" } 
          ]
        }
      ]
    }
  }
};

export const processRawConfigFn = (_widgetConfig) => {
  const processedConfig = {
    ..._widgetConfig,
    props: {
      ..._widgetConfig.props,
      tableData: _widgetConfig.props?.tableData
    }
  };

  return processedConfig;
}; 

export const someReqPropsUnset = WIDGET_ELEM_someReqPropsUnset; 